<template>
  <div class="list-panel app-container calendar-list-container">
    <basic-container>
      <el-row :gutter="20">
        <el-col :span="4" style="margin-top:15px;" v-show="false">
          <el-card class="box-card" shadow="never">
            <div class="clearfix" slot="header">
              <span>组织</span>
              <el-button @click="searchTree = searchTree ? false : true" class="card-heard-btn" icon="icon-filesearch" title="搜索" type="text"></el-button>
              <el-button @click="getTreeDept()" class="card-heard-btn" icon="icon-reload" title="刷新" type="text"></el-button>
            </div>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText" v-show="searchTree">
            </el-input>
            <el-tree :data="treeDeptData" :expand-on-click-node="false" :filter-node-method="filterNode" @node-click="clickNodeTreeData" class="filter-tree" highlight-current node-key="id" ref="leftDeptTree">
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="24">
          <div class="filter-container" v-show="searchFilterVisible">
            <el-form :inline="true" :model="searchForm" ref="searchForm" @submit.native.prevent>
              <el-form-item label="用户名称" prop="username">
                <el-input class="filter-item input-normal" size="small" v-model="searchForm.username" @keyup.enter.native="handleFilter" clearable></el-input>
              </el-form-item>
              <el-form-item label="所属组织" prop="deptName">
                <!-- <el-input class="filter-item input-normal" size="small" v-model="searchForm.deptName" @keyup.enter.native="handleFilter" clearable></el-input> -->
                <el-select filterable clearable v-model="searchForm.deptName" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in deptList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button @click="searchReset" icon="icon-rest" size="small">重置</el-button>
                <el-button @click="handleFilter" icon="el-icon-search" size="small" type="primary">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 表格功能列 -->

          <div class="table-menu">
            <div class="table-menu-left">
              <el-button @click="handleEdit" icon="el-icon-plus" size="mini" type="primary" v-if="sys_user_edit">添加
              </el-button>
            </div>
            <!-- <div class="table-menu-right">
              <el-button
                @click="searchFilterVisible = !searchFilterVisible"
                circle
                icon="el-icon-search"
                size="mini"
              ></el-button>
            </div> -->
          </div>
          <el-table :data="list" :key="tableKey" @sort-change="sortChange" element-loading-text="加载中..." fit highlight-current-row v-loading="listLoading" size="mini">
            <el-table-column fixed="left" type="index" width="40"></el-table-column>
            <el-table-column align="center" label="所属组织" min-width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.deptName }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="用户名" prop="a.username" sortable="custom" min-width="120">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.username }}
                </span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="邮箱" min-width="120">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.email }}
                </span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="手机号" min-width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="角色" min-width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.roleNames }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="是否可用" min-width="80">
              <template slot-scope="scope">
                <el-tag>{{ scope.row.availableText }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="创建时间" prop="a.created_date" sortable="custom" min-width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.createdDate }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" fixed="right" label="操作" v-if="sys_user_edit || sys_user_lock || sys_user_del" min-width="150">
              <template slot-scope="scope">
				<el-button @click="popLz(scope.row)" icon="el-icon-sort" type="primary" title="离职交接" size="mini" circle>
				</el-button>
                <el-button @click="handleEdit(scope.row)" icon="icon-edit" type="primary" title="编辑" size="mini" circle v-if="sys_user_edit">
                </el-button>
                <el-button :icon="scope.row.available == '0' ? 'icon-lock' : 'icon-unlock'" :title="scope.row.available == '0' ? '点击启用' : '点击禁用'" @click="handleLock(scope.row)" type="info" size="mini" circle
                  v-if="sys_user_lock">
                </el-button>
                <el-button @click="handleDelete(scope.row)" icon="icon-delete" type="danger" title="删除" size="mini" circle v-if="sys_user_del">
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container" v-show="!listLoading">
            <el-pagination :current-page.sync="listQuery.current" :page-size="listQuery.size" :page-sizes="[10, 20, 30, 50]" :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange" background
              class="pull-right" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
	  <!-- 离职交接 -->
	  <el-dialog :close-on-click-modal="false"  title="离职交接"  :modal-append-to-body="false"  :visible.sync="lzdialog" width="90%">
		<div class="contract-list">
			<div class="table-wrap">
			  <div class="top-box">
				  <span>用户名：{{userInfo.username||''}}</span>
				  <span>角色：{{userInfo.roleNames||''}}</span>
				  <span>所属组织：{{userInfo.deptName||''}}</span>
			  </div>
			  <div class="list-box">
				  <div class="select-box">
            <div>
              <span style="display: block; margin: 10px 0;">作为业务负责人的商务合同：</span>
              <span><el-checkbox v-model="checkbox1" @change="changeBox1">全选</el-checkbox></span>
            </div>
					 <div>
					   <el-checkbox-group v-model="tableData.contractList" style="width: 100%;overflow: hidden;">
						 <el-checkbox  v-for="(item,index) in htList" :key='index' :label="item.id" >{{item.name}}</el-checkbox>
					   </el-checkbox-group>
					 </div>
				  </div>
				  <div class="select-people">
					  <div style="margin-top: 30px;">业务负责人接收人：</div>
					  <el-input :value="tableData.name1">
					    <i slot="append" @click="selectBox(1)"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
					  </el-input>
				  </div>
			  </div>
			  <div class="list-box">
				  <div class="select-box">
            <div>
              <span style="display: block; margin: 10px 0;">作为有花果负责人的框架协议：</span>
              <span><el-checkbox v-model="checkbox2" @change="changeBox2">全选</el-checkbox></span>
            </div>
					 <div>
					   <el-checkbox-group v-model="tableData.frameworkAgreementList">
						 <el-checkbox  v-for="(item,index) in htList2" :key='index' :label="item.id">{{item.name}}</el-checkbox>
					   </el-checkbox-group>
					 </div>
				  </div>
				  <div class="select-people">
					  <div style="margin-top: 30px;">有花果负责人接收人：</div>
					  <el-input :value="tableData.name2">
						<i slot="append" @click="selectBox(2)"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
					  </el-input>
				  </div>
			  </div>
			  <div class="list-box">
				  <div class="select-box">
            <div>
              <span style="display: block; margin: 10px 0;">作为项目负责人的品牌：</span>
              <span><el-checkbox v-model="checkbox3" @change="changeBox3">全选</el-checkbox></span>
            </div>
					 <div>
					   <el-checkbox-group v-model="tableData.brandList">
						 <el-checkbox  v-for="(item,index) in htList3" :key='index' :label="item.id">{{item.name}}</el-checkbox>
					   </el-checkbox-group>
					 </div>
				  </div>
				  <div class="select-people">
					  <div style="margin-top: 30px;">项目负责人接收人：</div>
					  <el-input :value="tableData.name3">
						<i slot="append" @click="selectBox(3)"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
					  </el-input>
				  </div>
			  </div>
			  <div class="list-box">
				  <div class="select-box">
            <div>
              <span style="display: block; margin: 10px 0;">作为合同负责人的品牌合同：</span>
              <span><el-checkbox v-model="checkbox4" @change="changeBox4">全选</el-checkbox></span>
            </div>
					 <div>
					   <el-checkbox-group v-model="tableData.brandContractList">
						 <el-checkbox  v-for="(item,index) in htList4" :key='index' :label="item.id">{{item.name}}</el-checkbox>
					   </el-checkbox-group>
					 </div>
				  </div>
				  <div class="select-people">
					  <div style="margin-top: 30px;">合同负责人接收人：</div>
					  <el-input :value="tableData.name4">
						<i slot="append" @click="selectBox(4)"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
					  </el-input>
				  </div>
			  </div>
			  <div style="margin-top: 20px;">Tips：工作交接提交成功需要较长时间，请在提交成功后再关闭页面。</div>
			  <div style="text-align:center;margin-top: 25px;" >
			   <el-button style="width:120px;" @click="saveClick('ruleForm')" type="primary">提交</el-button>
			  </div>
			  <!-- //盖章经办人弹框 -->
			  <sealPeople ref="sealp" :blockId='userInfo.id' @select="selectPeople"></sealPeople>
			</div>
		</div>
	  </el-dialog>
	  <!-- 离职交接结束 -->
      <el-dialog :visible.sync="dialogDeptVisible" title="选择组织">
        <!-- <el-tree :data="treeDeptData" :default-checked-keys="checkedKeys" @node-click="clickNodeSelectData" check-strictly class="filter-tree" show-checkbox default-expand-all highlight-current node-key="id"> -->
        <el-tree :data="treeDeptData" :default-checked-keys="checkedKeys" @check-change="handleNodeClick" check-strictly class="filter-tree" show-checkbox default-expand-all highlight-current node-key="id" ref="tree">
        </el-tree>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
        <el-form :model="form" label-width="100px" ref="form">
          <!--      <el-form-item label="头像" prop="avatar">-->
          <!--        <my-upload field="uploadFile" @crop-upload-success="cropUploadSuccess" v-model="showUpload"-->
          <!--                   :width="300" :height="300" :url="ctx+'/file/upload'" :headers="headers" img-format="png"></my-upload>-->
          <!--        <img :src="getFilePath(form.avatar)" class="header-img" />-->
          <!--        <input type="hidden" v-model="form.avatar" />-->
          <!--        <el-button type="primary" @click="showUpload = !showUpload" size="mini">选择-->
          <!--          <i class="el-icon-upload el-icon--right"></i>-->
          <!--        </el-button>-->
          <!--      </el-form-item>-->
          <el-form-item :rules="[
              { required: true, message: '请选择组织', trigger: 'change' }
            ]" label="所属组织" prop="deptName">
            <el-input @focus="dialogDeptVisible = true" placeholder="选择组织" readonly v-model="form.deptName">
            </el-input>
            <input type="hidden" v-model="form.deptId" />
          </el-form-item>

          <el-form-item :rules="[
              { required: true, message: '请输入用户名', trigger: 'blur' },
              { min: 1, message: '至少输入一个字符', trigger: 'blur' },
              { validator: validateUnique, trigger: 'blur' }
            ]" label="用户名" prop="username">
            <input type="text" id="hideUsername" style="position: fixed;bottom: -9999px">
            <el-input placeholder="请输入用户名" v-model="form.username" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item :rules="this.dialogStatus == 'create' ? [{ validator: validatePass }] : []" label="密码" prop="password" autocomplete="off">
            <input type="password" id="hidePassword" style="position: fixed;bottom: -9999px">
            <el-input :placeholder="
                this.dialogStatus == 'create'
                  ? '请输入密码'
                  : '若不修改密码，请留空'
              " type="password" v-model="form.password"></el-input>
          </el-form-item>

          <el-form-item :rules="[{ validator: validateConfirmPass }]" label="确认密码" placeholder="请再次输入密码" prop="confirmPassword">
            <el-input type="password" v-model="form.confirmPassword"></el-input>
          </el-form-item>

          <el-form-item :rules="[{ validator: validatePhone }]" label="手机号" prop="phone">
            <el-input placeholder="" v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="钉钉号" prop="ddUserid">
            <el-input placeholder="钉钉号" v-model="form.ddUserid"></el-input>
          </el-form-item>
          <el-form-item :rules="[{ validator: validateEmail }]" label="邮箱" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>

          <el-form-item :rules="[{ required: true, message: '请选择角色', trigger: 'change' }]" label="角色" prop="roleIdList">
            <el-select v-model="form.roleIdList" class="w-100" multiple>
              <el-option v-for="(item, index) in rolesOptions" :key="index" :label="item.name" :value="item.id" :disabled="item.disabled"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :rules="[{ required: true, message: '请选择', trigger: 'change' }]" label="是否可用" prop="available">
            <el-radio-group v-model="form.available">
              <el-radio v-for="(item, index) in flagOptions" :key="index" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="备注" prop="description">
            <el-input placeholder="" maxlength="300" show-word-limit type="textarea" v-model="form.description"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" slot="footer">
          <el-button @click="cancel()" size="small">取 消</el-button>
          <el-button @click="resetForm()" size="small">重 置</el-button>
          <el-button @click="save()" size="small" type="primary">保 存</el-button>
        </div>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import sealPeople from "@/components/common/sealPeople";//引入选择盖章经办人
import {
	dataList,lzComit
} from "./index.js";
import userService from "./user-service";
import deptService from "../dept/dept-service";
import roleService from "../role/role-service";
import { mapGetters } from "vuex";
import util from "@/util/util";
import validate from "@/util/validate";

export default {
  name: "User",
  components: {
  	sealPeople,
  },
  data() {
    return {
		// 离职交接模块
	  lzdialog:false,
	  peopleType:null,//1业务负责人接收人2业务负责人接收人3项目负责人接收人4合同负责人接收人
	  userInfo:{},//用户信息
	  name:'',
	  checkList:[1],//商务合同列表
	  checkList2:[1],//框架协议列表
	  checkList3:[1],//品牌列表
	  htList:[],//商务合同列表
	  htList2:[],//框架协议列表
	  htList3:[],//品牌列表
	  htList4:[],//品牌合同列表
	  tableData:{
	  	name1:'',
	  	name2:'',
	  	name3:'',
	  	name4:'',
	  	brandContractList:[],//品牌合同ids
	  	brandContractReceiveId:'',//品牌合同接收人id
	  	brandList:[],//品牌ids
	  	brandReceiveId:'',//品牌接收人id
	  	contractList:[],//商务合同ids
	  	contractReceiveId:'',//商务合同接收人id
	  	frameworkAgreementList:[],//框架协议ids
	  	frameworkAgreementReceiveId:'',//框架协议接收人id
	  },
	  
      treeDeptData: [],
      dialogDeptVisible: false,
      dialogFormVisible: false,
      searchFilterVisible: true,
      checkedKeys: [],
      list: null,
      total: null,
      listLoading: true,
      searchForm: {
        username: "",
        deptName: "",
      },
      listQuery: {
        current: 1,
        size: 20,
      },
      formEdit: true,
      filterText: "",
      filterFormText: "",
      formStatus: "",
      flagOptions: [],
      rolesOptions: [],
      searchTree: false,
      labelPosition: "right",
      checkbox1:false,
      checkbox2:false,
      checkbox3:false,
      checkbox4:false,
      form: {
        username: undefined,
        deptId: undefined,
        password: undefined,
        confirmPassword: undefined,
        phone: undefined,
        email: undefined,
        roleIdList: [],
        available: undefined,
        description: undefined,
        ddUserid:"",
      },
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      validateUnique: (rule, value, callback) => {
        validate.isUnique(
          rule,
          value,
          callback,
          "/a/sys/user/checkByProperty?id=" + util.objToStr(this.form.id)
        );
      },
      validateEmail: (rule, value, callback) => {
        if (!validate.checkNull(value)) {
          if (!validate.email(value)) {
            callback(new Error("请输入正确的邮箱"));
            return;
          }
        }
        callback();
      },
      validatePhone: (rule, value, callback) => {
        if (!validate.checkNull(value)) {
          if (!validate.mobile(value)) {
            callback(new Error("请输入正确的手机号"));
            return;
          }
        }
        callback();
      },
      validatePass: (rule, value, callback) => {
        if (validate.checkNull(this.form.id)) {
          if (validate.checkNull(value)) {
            callback(new Error("请输入密码"));
            return;
          } else {
            if (value.length < 6) callback(new Error("密码至少为6位"));
          }
        } else {
          if (!validate.checkNull(value)) {
            if (value.length < 6) callback(new Error("密码至少为6位"));
          }
        }
        callback();
      },
      validateConfirmPass: (rule, value, callback) => {
        if (validate.checkNotNull(this.form.password)) {
          if (validate.checkNull(value)) {
            callback(new Error("请再次输入密码"));
            return;
          } else if (value !== this.form.password) {
            callback(new Error("两次输入密码不一致!"));
            return;
          }
        }
        callback();
      },
      dialogStatus: "create",
      textMap: {
        update: "编辑",
        create: "创建",
      },
      sys_user_edit: false,
      sys_user_lock: false,
      sys_user_del: false,
      currentNode: {},
      tableKey: 0,
      deptList:[]
    };
  },
  watch: {
    filterText(val) {
      this.$refs["leftDeptTree"].filter(val);
    },
  },
  created() {
    this.getTreeDept();
    this.getList();
    this.sys_user_edit = this.permissions["sys_user_edit"];
    this.sys_user_lock = this.permissions["sys_user_lock"];
    this.sys_user_del = this.permissions["sys_user_del"];
    roleService.deptRoleList({ queryAll: true }).then((response) => {
      response.data.forEach((r) => {
        r.disabled = r.available === "0" ? true : false;
        // console.log(r.available);
      });
      this.rolesOptions = response.data;
    });
    this.flagOptions = this.dicts["sys_flag"];
    userService.deptList().then(res=>{
      this.deptList = res.data
      console.log('===所属组织====',res)
    })
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    changeBox1(){
      if(this.checkbox1){
        console.log(true) ;
        for(var i = 0 ; i <= this.htList.length; i++){ 
          console.log(this.htList[i].id)
          this.tableData.contractList.push(this.htList[i].id) ;
        }
      }else{
          this.tableData.contractList = [] ;
      }
    },

    changeBox2(){
      if(this.checkbox2){
        console.log(true) ;
        for(var i = 0 ; i <= this.htList2.length; i++){ 
          console.log(this.htList2[i].id)
          this.tableData.frameworkAgreementList.push(this.htList2[i].id) ;
        }
      }else{
          this.tableData.frameworkAgreementList = [] ;
      }
    },

    changeBox3(){
      if(this.checkbox3){
        console.log(true) ;
        for(var i = 0 ; i <= this.htList3.length; i++){ 
          console.log(this.htList3[i].id)
          this.tableData.brandList.push(this.htList3[i].id) ;
        }
      }else{
          this.tableData.brandList = [] ;
      }
    },

    changeBox4(){
      if(this.checkbox4){
        console.log(true) ;
        for(var i = 0 ; i <= this.htList4.length; i++){ 
          console.log(this.htList4[i].id)
          this.tableData.brandContractList.push(this.htList4[i].id) ;
        }
      }else{
          this.tableData.brandContractList = [] ;
      }
    },
	 // 离职交接
	 // 点击离职按钮
	 popLz(row){
		 this.lzdialog = true
		 this.userInfo = row;
     this.checkbox1 = false ;
     this.checkbox2 = false ;
     this.checkbox3 = false ;
     this.checkbox4 = false ;
     this.tableData.contractList = [] ;
     this.tableData.frameworkAgreementList = [] ;
     this.tableData.brandList = [] ;
     this.tableData.brandContractList = [] ;

		 console.log(this.userInfo)
		 this.getHtList();
	 },
	 //打开选择人弹框
	 selectBox(number){
	 	this.peopleType = number
	 	this.$refs.sealp.title = '选择接收人'
	 	this.$refs.sealp.adminListModal=true
	 },
	 //选择经办人
	 selectPeople(row){
	 	console.log(this.peopleType)
	 	console.log(row)
	 	if(this.peopleType==1){
	 		this.tableData.contractReceiveId = row.id
	 		this.tableData.name1 = row.username
	 	}else if(this.peopleType==2){
	 		this.tableData.frameworkAgreementReceiveId = row.id
	 		this.tableData.name2 = row.username
	 	}else if(this.peopleType==3){
	 		this.tableData.brandReceiveId = row.id
	 		this.tableData.name3 = row.username
	 	}else if(this.peopleType==4){
	 		this.tableData.brandContractReceiveId = row.id
	 		this.tableData.name4 = row.username
	 	}
	 },
	 //提交
	 saveClick() {
	 	console.log(this.tableData)
	 	if(this.userInfo.id == this.tableData.brandContractReceiveId ||
	 	 this.userInfo.id == this.tableData.brandReceiveId ||
	 	 this.userInfo.id == this.tableData.contractReceiveId ||
	 	 this.userInfo.id == this.tableData.frameworkAgreementReceiveId
	 	 ){
	 		 this.$message({
	 		   message: '接收人不能选择自己',
	 		   type: 'warning'
	 		 });
	 		 return
	 	 }
     this.tableData.userId = this.userInfo.id ;
	 	lzComit(this.tableData).then((res) => {
	 		if (res.code == 1) {
	 			this.$message.success("提交成功！");
	 			this.getHtList();
	 		}
	 	});
	 },
	 // 获取列表
	 getHtList() {
	   const obj = {
	 	  userId : this.userInfo.id
	   }
	   dataList(obj)
	 	.then((res) => {
	 		this.htList = res.data.contractList
	 		this.htList2 = res.data.frameworkAgreementList
	 		this.htList3 = res.data.brandList
	 		this.htList4 = res.data.brandContractList
	 		this.$forceUpdate()
	 	})
	 	.catch((err) => {
	 		
	 	});
	 },
	  
	  
	  
    getList() {
      this.listLoading = true;
      // this.listQuery.isAsc = false;
      this.searchForm.username =
        typeof this.searchForm.username == "string"
          ? this.searchForm.username
          : "";
      this.listQuery.queryConditionJson = util.parseJsonItemForm([
        {
          fieldName: "a.username",
          value: this.searchForm.username.trim(),
        },
        {
          fieldName: "a.dept_id",
          value: this.searchForm.deptId,
        },
        {
          "format":"",
          "fieldName":'d.id',
          "attrType":"String",
          "fieldNode":"",
          "operate":"in",
          "weight":0,
          "value":this.searchForm.deptName.trim(),
          "endValue":""
        }
      ]);
      userService.page(this.listQuery).then((response) => {
        this.list = response.data.records;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    sortChange(column) {
      if (column.order == "ascending") {
        this.listQuery.ascs = column.prop;
        this.listQuery.descs = undefined;
      } else {
        this.listQuery.descs = column.prop;
        this.listQuery.ascs = undefined;
      }
      this.getList();
    },
    getTreeDept() {
      deptService.fetchTree().then((response) => {
        this.treeDeptData = util.parseTreeData(response.data);
        this.treeDeptData[0].disabled = true;
        this.searchForm.parentId = this.treeDeptData[0].id;
        setTimeout(() => {
          this.$refs.leftDeptTree.setCurrentKey(this.searchForm.parentId);
        }, 0);
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    clickNodeTreeData(data) {
      this.searchForm.deptId = data.id;
      this.currentNode = data;
      this.getList();
    },
    clickNodeSelectData(data) {
      this.form.deptId = data.id;
      this.form.deptName = data.label;
      this.dialogDeptVisible = false;
    },
    handleNodeClick(data, checked, node) {
      if (checked === true) {
        this.form.deptId = data.id;
        this.form.deptName = data.label;
        this.$refs.tree.setCheckedKeys([data.id]);
        this.dialogDeptVisible = false;
      }
    },
    //搜索清空
    searchReset() {
      this.$refs["searchForm"].resetFields();
      // this.listQuery.deptId = undefined;
      // this.$refs["leftDeptTree"].setCurrentKey(null);
      this.handleFilter();
    },
    handleFilter() {
      this.listQuery.current = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.current = val;
      this.getList();
    },
    handleEdit(row) {
      this.resetForm();
      this.dialogStatus =
        row && validate.checkNotNull(row.id) ? "update" : "create";
      if (this.dialogStatus == "create") {
        this.dialogFormVisible = true;
        this.form.username = "";
        this.form.password = "";
      } else {
        userService.find(row.id).then((response) => {
          this.form = response.data;
          this.form.password = undefined;
          this.dialogFormVisible = true;
        });
      }
    },
    handleLock: function (row) {
      userService.lock(row.id).then((response) => {
        this.getList();
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        userService.remove(row.id).then((response) => {
          this.getList();
        });
      });
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          userService.save(this.form).then((response) => {
            this.getList();
            this.dialogFormVisible = false;
          });
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.dialogFormVisible = false;
      this.$refs["form"].resetFields();
    },
    resetForm() {
      this.form = {
        username: undefined,
        deptId: undefined,
        deptName: undefined,
        password: undefined,
        confirmPassword: undefined,
        phone: undefined,
        email: undefined,
        roleIdList: [],
        available: undefined,
        description: undefined,
      };
      this.$refs["form"] && this.$refs["form"].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
	.select-box{
		 width: 70%;
	}
	.top-box{
		display: flex;
		justify-content: space-around;
	}
	.list-box{
		display: flex;
		justify-content: space-between;
		border: 1px solid #e3e3e3;
		padding: 10px;
		border-radius: 10px;
		margin-top: 10px;
	}
	//蓝色选择图标
	.el-input-group__append {
	  position: relative;
	  width: 32px;
	  height: 32px;
	  border: none;
	  background: #fff;
	  padding: 0;
	  color: #409eff !important;
	  .iconfont {
	    position: absolute;
	    top: 0;
	    left: 0;
		  right: 0;
		  bottom: 0;
		  margin: auto;
	    font-size: 33px !important;
		   color: #409eff !important;
		   margin: 0 auto !important;
		   text-align: center !important;
	  }
	  cursor: pointer;
	}
	
	
	
	
	.dz-img {
		display: block;
		width: 90px;
		height: 100px;
		margin: 0 auto;
	}

	.dz-title {
		font-size: 30px;
		color: #000;
		font-weight: bold;
		text-align: center;
		padding: 10px;
	}

	.dz-text {
		text-align: center;
		padding: 20px;
	}

	.dz-info {
		display: flex;
		justify-content: space-around;
		padding: 20px;
	}


	.mar-c {
		display: flex;
		justify-content: center;
	}

	.table-count {
		margin: 15px 0 10px;
	}

	// 列表item
	.block-form-item {
		&.w-32 {
			display: inline-block;
			width: 32%;
			margin-right: 1%;
			height: 64px;
		}

		&.w-99 {
			width: 99%;
			margin-right: 1%;
		}
	}

	.yhg-dialog {
		.select-con {
			display: flex;

			.label {
				white-space: nowrap;
			}

			.select-tag {
				margin-right: 5px;
				margin-bottom: 5px;
			}

			.select-tag-text {
				display: inline-block;
				max-width: 86px;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.filter-con {
			display: flex;
			align-items: center;
			margin: 20px 0;
			width: 800px;

			.label {
				white-space: nowrap;
			}

			.search-btn {
				margin-left: 15px;
			}
		}

		.submit-con {
			margin-top: 20px;
			text-align: right;
		}
	}

	.select-input-wrap-s {
		.el-input-group__append {
			position: relative;
			width: 32px;
			height: 32px;
			border: none;
			background: #fff;
			padding: 0;
			color: #409eff;

			.iconfont {
				position: absolute;
				top: -2px;
				left: -1px;
				font-size: 33px !important;
			}

			cursor: pointer;
		}
	}

	.select-con {
		.el-tag .el-icon-close {
			top: -8px;
		}
	}

	.avue-view .cost-table {
		width: calc(50% + 100px);

		th {
			background: none;
			font-weight: normal;
			font-size: 14px;
		}

		.cell {
			padding-left: 0;
		}
	}

	.el-table .operate-column {
		vertical-align: text-top;
	}

	/deep/.el-dialog__header {
		border-bottom: 1px solid #ccc !important;
	}

	.invoiceList {
		display: flex;
		justify-content: space-between;
	}

	.mt-10 {
		margin-top: 10px;
	}
</style>
<style>
	.el-dialog {
	    width: 70%;
	}
	.el-icon-delete-solid:hover{
		color: #66B1FF;
	}
	.el-icon-delete-solid{
		cursor: pointer;
	}
	.el-checkbox+.el-checkbox {
		margin-left: 0px;
		margin-top: 10px;
	}
</style>

